export default "__VITE_ASSET__DRLXEDtq__"